import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UiButtonModule } from '@radioking/ui/button';

import { ProductFeatureComponent } from './components/product-feature/product-feature.component';
import { ShareBottomActionComponent } from './components/share-bottom-action/share-bottom-action.component';
import { ShareContentWrapperComponent } from './components/share-content-wrapper/share-content-wrapper.component';
import { ShareHintComponent } from './components/share-hint/share-hint.component';
import { ShareMarketingShellComponent } from './components/share-marketing-shell/share-marketing-shell.component';
import { SharePageWrapperComponent } from './components/share-page-wrapper/share-page-wrapper.component';
import { ShareTitleComponent } from './components/share-title/share-title.component';
import { ShareWidgetShellComponent } from './components/share-widget-shell/share-widget-shell.component';

@NgModule({
  declarations: [
    ShareTitleComponent,
    SharePageWrapperComponent,
    ShareHintComponent,
    ShareContentWrapperComponent,
    ShareBottomActionComponent,
    ShareWidgetShellComponent,
    ProductFeatureComponent,
    ShareMarketingShellComponent,
  ],
  imports: [CommonModule, UiButtonModule, TranslateModule],
  exports: [
    ShareTitleComponent,
    SharePageWrapperComponent,
    ShareHintComponent,
    ShareContentWrapperComponent,
    ShareBottomActionComponent,
    ShareWidgetShellComponent,
    ProductFeatureComponent,
    ShareMarketingShellComponent,
  ],
})
export class ShareUiModule {}
